import { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { motion, AnimatePresence } from "framer-motion";

const LoginModal = () => {
  const { showLogin, setShowLogin, login, isLoading } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegisterMode, setIsRegisterMode] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isRegisterMode) {
      if (password !== confirmPassword) {
        alert("Пароли не совпадают");
        return;
      }
      if (!name.trim()) {
        alert("Пожалуйста, введите ваше имя");
        return;
      }
    }

    login(email, password, isRegisterMode, name);
  };

  const switchMode = () => {
    setIsRegisterMode(!isRegisterMode);
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setName("");
  };

  return (
    <AnimatePresence>
      {showLogin && (
        <motion.div
          className="login-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="login-modal"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ type: "spring", damping: 25 }}
          >
            <div className="login-header">
              <h2>{isRegisterMode ? "Регистрация" : "Вход в аккаунт"}</h2>
              <button
                className="close-btn"
                onClick={() => setShowLogin(false)}
                disabled={isLoading}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              {isRegisterMode && (
                <div className="form-group">
                  <label>Имя</label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    disabled={isLoading}
                    placeholder="Ваше имя"
                  />
                </div>
              )}

              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={isLoading}
                  placeholder="example@mail.com"
                />
              </div>

              <div className="form-group">
                <label>Пароль</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={isLoading}
                  placeholder="••••••••"
                  minLength="6"
                />
              </div>

              {isRegisterMode && (
                <div className="form-group">
                  <label>Подтвердите пароль</label>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    disabled={isLoading}
                    placeholder="••••••••"
                  />
                </div>
              )}

              <motion.button
                type="submit"
                className="login-btn"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="spinner"></span>
                ) : isRegisterMode ? (
                  "Зарегистрироваться"
                ) : (
                  "Войти"
                )}
              </motion.button>
            </form>

            <div className="login-footer">
              <span onClick={switchMode}>
                {isRegisterMode
                  ? "Уже есть аккаунт? Войти"
                  : "Нет аккаунта? Зарегистрироваться"}
              </span>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoginModal;
